// Expense service using repository pattern
import { Expense } from '@/shared/types';
import { expenseRepository } from '@/shared/lib/repositories/ExpenseRepository';
import { realDataService } from '@/shared/services/realDataService';

export const expenseService = {
  getExpenses: async (): Promise<Expense[]> => {
    const profile = await realDataService.getProfile();
    if (!profile) {
      throw new Error('Profile not found');
    }
    const userId = profile.userId || '';

    const result = await expenseRepository.findByUserId(userId);
    if (!result.success) {
      throw new Error(result.error || 'Failed to fetch expenses');
    }
    return result.data || [];
  },

  createExpense: async (expenseData: Partial<Expense>): Promise<Expense> => {
    const profile = await realDataService.getProfile();
    if (!profile) {
      throw new Error('Profile not found');
    }
    const userId = profile.userId || '';

    const { id, ...data } = expenseData as Expense;
    const result = await expenseRepository.create(userId, data);
    if (!result.success) {
      throw new Error(result.error || 'Failed to create expense');
    }
    return result.data!;
  },

  updateExpense: async (expense: Expense): Promise<void> => {
    const result = await expenseRepository.update(expense.id, expense);
    if (!result.success) {
      throw new Error(result.error || 'Failed to update expense');
    }
  },

  deleteExpense: async (id: string): Promise<void> => {
    const result = await expenseRepository.delete(id);
    if (!result.success) {
      throw new Error(result.error || 'Failed to delete expense');
    }
  },

  // Legacy method names
  addExpense: async (expense: Expense): Promise<void> => {
    const profile = await realDataService.getProfile();
    if (!profile) {
      throw new Error('Profile not found');
    }
    const userId = profile.userId || '';

    const { id, ...data } = expense;
    const result = await expenseRepository.create(userId, data);
    if (!result.success) {
      throw new Error(result.error || 'Failed to add expense');
    }
  }
};
